/**
 * Who asked a profile-chat conversation, from the strongest identity we hold.
 *
 * One rule for the list and the detail page. It lived in both, and the copies
 * had already drifted — the detail page dropped the fund name, so one
 * conversation read "Jane · Acme Fund" in the list and "Jane" once opened.
 *
 * 1. A named contact — only a per-investor outreach link has one.
 * 2. Otherwise the email the visitor typed into a door. It is self-reported, so
 *    the suffix says which kind of link it was typed on. That is decided by the
 *    link itself, never inferred from the missing contact name: an outreach
 *    visit whose contact row is gone is still an outreach visit.
 * 3. Otherwise "Anonymous" — a visitor who never identified themselves.
 */

export interface ChatAttributionInput {
  anonymized: boolean
  contactName: string | null
  investorName: string | null
  visitorEmail: string | null
  viaOutreachLink: boolean
}

export function chatAttribution(conversation: ChatAttributionInput): string {
  if (conversation.anonymized) return 'Anonymised'
  if (conversation.contactName) {
    return conversation.investorName
      ? `${conversation.contactName} · ${conversation.investorName}`
      : conversation.contactName
  }
  if (conversation.visitorEmail) {
    const link = conversation.viaOutreachLink ? 'outreach link' : 'founder link'
    return `${conversation.visitorEmail} · ${link}`
  }
  return 'Anonymous'
}
